import React from "react";
import Customiser from "./Customiser";
import { FlexCol } from "components-shared/Layout";
import { useWebTranslation } from "translations";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import { toFirstLetterUpperCase } from "utils/utils";
import { BillingInterval } from "utils/insurance";

type ChoosePaymentIntervalProps = {
  value: BillingInterval;
  onChange: (value: BillingInterval) => void;
  smallTitle?: boolean;
};

const ChoosePaymentInterval = ({
  value,
  onChange,
  smallTitle,
}: ChoosePaymentIntervalProps) => {
  const { t } = useWebTranslation();
  return (
    <FlexCol>
      {smallTitle ? (
        <Typography color="grey500">
          <strong>{t("global.payment_interval")}</strong>
        </Typography>
      ) : (
        <Typography variant="h3" color="grey500">
          {t("global.payment_interval")}
        </Typography>
      )}
      <Gutter size={3} />
      <Customiser
        name="billingInterval"
        options={[1, 12].map((billingInterval) => ({
          value: billingInterval,
          title: toFirstLetterUpperCase(
            billingInterval === 12
              ? t("global.date.yearly")
              : t("global.date.monthly")
          ),
        }))}
        value={value}
        onChange={(billingInterval) =>
          onChange(billingInterval as BillingInterval)
        }
      />
    </FlexCol>
  );
};

export default ChoosePaymentInterval;
